import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import redial from 'redial'
import {
  changeActiveList,
  fetchUserItems,
  fetchUserItemsNext,
  unqueueItems,
  LIST_NAME_PERSONAL,
  LIST_TYPE_MAIN,
} from '../../components/item/itemsActions'
import AbstractListView, { connectGenericProps } from './AbstractListView'
import { selectUserWhitelistedTagIds, selectUserWhitelistedCategoryIds } from '../../selectors/userSelector'
import PersonalItemsEmpty from './PersonalItemsEmpty'
import PersonalItemsInstructions from './PersonalItemsInstructions'
import { fetchPopular } from '../../components/item/popularActions'

@redial.provideHooks({
  fetch: ({ dispatch }) => {

    dispatch(changeActiveList(LIST_TYPE_MAIN, LIST_NAME_PERSONAL))

    return Promise.all([
      dispatch(fetchUserItems()),
      dispatch(fetchPopular(300)),
    ])
  },
})

class PersonalView extends AbstractListView {
  constructor (props) {
    super(props)

    this.state = Object.assign(this.state, {
      // Prop decides if instructions are shown, state makes them stay visible until unmounted
      showInstructions: props.showInstructions,
    })
  }

  static propTypes = { // eslint-disable-line react/prefer-exact-props
    dispatch: PropTypes.func.isRequired,
  }

  refreshList() {
    const { dispatch } = this.props
    dispatch(fetchUserItems())
  }

  fetchNext(timestamp) {
    return (dispatch) => dispatch(fetchUserItemsNext(timestamp))
  }

  unqueueItems() {
    const { dispatch } = this.props
    dispatch(unqueueItems(LIST_NAME_PERSONAL))
  }

  renderInstructions() {
    if (this.state.showInstructions) {
      return <PersonalItemsInstructions />
    }
  }

  renderEmpty() {
    const { loggedIn } = this.props

    if (!this.state.showInstructions) {
      return <PersonalItemsEmpty loggedIn={ loggedIn } />
    }
  }

  setActiveList() {
    const { dispatch } = this.props

    dispatch(changeActiveList(LIST_TYPE_MAIN, LIST_NAME_PERSONAL))
  }

  getMetaDescription() {
    return 'Ampparit.com tarjoaa kattavasti koko Suomen uutisoinnin, mutta Omat aiheet -listalla päätät itse, mitä ' +
      'uutisaiheita seuraat. Voit myös lisätä mukaan omia uutislähteitä. Se kattavin uutistarjonta \u2013 Ampparit.com'
  }

  getTitle() {
    return 'Omat aiheet | Tuoreimmat uutiset | Ampparit.com'
  }

  getH1() {
    return 'Omat aiheet | Uutiset'
  }
}

export default connect(state => {
  const personal = state.items.lists.get(LIST_NAME_PERSONAL)

  const showInstructions =
    selectUserWhitelistedCategoryIds(state).isEmpty() &&
    selectUserWhitelistedTagIds(state).isEmpty()


  return Object.assign(connectGenericProps(state, personal), {
    showInstructions,
    personalListShouldRefresh: personal.get('shouldRefresh'),
  })
})(PersonalView)
